import {
  COMMON_PROPERTY_NAMES,
  DYNAMIC_PROPERTY_NAMES,
  FIELD_PROPERTY_NAMES,
  FORM_PROPERTY_NAMES,
  GROUP_PROPERTY_NAMES,
  PAGE_PROPERTY_NAMES,
} from './property-names'

export const COMMON_PROPERTY_SCHEMA_NAMES = {
  NAME: COMMON_PROPERTY_NAMES.NAME,
  LOCALIZATION_KEY: COMMON_PROPERTY_NAMES.LOCALIZATION_KEY,
  DISPLAY_NAME: COMMON_PROPERTY_NAMES.DISPLAY_NAME,
  DESCRIPTION: COMMON_PROPERTY_NAMES.DESCRIPTION,
  INVISIBLE_BORDER: GROUP_PROPERTY_NAMES.INVISIBLE_BORDER,
}
export const DYNAMIC_PROPERTY_SCHEMA_NAMES = {
  LABEL_EXP: DYNAMIC_PROPERTY_NAMES.LABEL_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_NAMES.COLLAPSED_EXP,
  SAVE_EXP: DYNAMIC_PROPERTY_NAMES.SAVE_EXP,
  REQUIRED: DYNAMIC_PROPERTY_NAMES.REQUIRED,
  REQUIRED_EXP: DYNAMIC_PROPERTY_NAMES.REQUIRED_EXP,
  VALUE_EXP: DYNAMIC_PROPERTY_NAMES.VALUE_EXP,
  LIST_EXP: DYNAMIC_PROPERTY_NAMES.LIST_EXP,
  FILTER_EXP: DYNAMIC_PROPERTY_NAMES.FILTER_EXP,
}
export const FORM_PROPERTY_SCHEMA_NAMES = {
  FORM_NAME: FORM_PROPERTY_NAMES.FORM_NAME,
  LOCALIZATION_KEY: COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY,
  DISPLAY_NAME: COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME,
  DESCRIPTION: COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION,
  SYSTEM: FORM_PROPERTY_NAMES.SYSTEM,
  MAIN_TABLE: FORM_PROPERTY_NAMES.MAIN_TABLE,
  URL: FORM_PROPERTY_NAMES.URL,
  MENU_ASSIGNER: FORM_PROPERTY_NAMES.MENU_ASSIGNER,
  TAGS: FORM_PROPERTY_NAMES.TAGS,
  HIDDEN_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP,
  SAVE_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.SAVE_EXP,
} as const
export const PAGE_PROPERTY_SCHEMA_NAMES = {
  NAME: COMMON_PROPERTY_SCHEMA_NAMES.NAME,
  LOCALIZATION_KEY: COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY,
  DISPLAY_NAME: COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME,
  DESCRIPTION: PAGE_PROPERTY_NAMES.DESCRIPTION,
  LABEL_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.LABEL_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.COLLAPSED_EXP,
}
export const GROUP_PROPERTY_SCHEMA_NAMES = {
  NAME: COMMON_PROPERTY_SCHEMA_NAMES.NAME,
  LOCALIZATION_KEY: COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY,
  DISPLAY_NAME: COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME,
  DESCRIPTION: GROUP_PROPERTY_NAMES.DESCRIPTION,
  LABEL_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.LABEL_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_SCHEMA_NAMES.COLLAPSED_EXP,
  INVISIBLE_BORDER: GROUP_PROPERTY_NAMES.INVISIBLE_BORDER,
}
export const FIELD_PROPERTY_SCHEMA_NAMES = {
  NAME: COMMON_PROPERTY_NAMES.NAME,
  MULTISELECT_NAME: FIELD_PROPERTY_NAMES.MULTISELECT_NAME,
  DESCRIPTION: COMMON_PROPERTY_NAMES.DESCRIPTION,
  LOCALIZATION_KEY: COMMON_PROPERTY_NAMES.LOCALIZATION_KEY,
  DISPLAY_NAME: COMMON_PROPERTY_NAMES.DISPLAY_NAME,
  PLACEHOLDER: FIELD_PROPERTY_NAMES.PLACEHOLDER,
  DATE_PICKER_VIEW: FIELD_PROPERTY_NAMES.DATE_PICKER_VIEW,
  READ_ONLY: FIELD_PROPERTY_NAMES.READ_ONLY,
  LINK_TYPE: FIELD_PROPERTY_NAMES.LINK_TYPE,
  UNDERLINE: FIELD_PROPERTY_NAMES.UNDERLINE,
  PREFIX_ICON: FIELD_PROPERTY_NAMES.PREFIX_ICON,
  THOUSAND_SEPARATED: FIELD_PROPERTY_NAMES.THOUSAND_SEPARATED,
  TAGGABLE: FIELD_PROPERTY_NAMES.TAGGABLE,
  CAPTCHA_TYPE: FIELD_PROPERTY_NAMES.CAPTCHA_TYPE,
  REF_TABLE: FIELD_PROPERTY_NAMES.REF_TABLE,
  REL_FORM_ID: FIELD_PROPERTY_NAMES.REL_FORM_ID,
  REL_FIELD: FIELD_PROPERTY_NAMES.REL_FIELD,
  SUB_ID_FORM: FIELD_PROPERTY_NAMES.SUB_ID_FORM,
  SUB_COLUMN_NAME_MAIN: FIELD_PROPERTY_NAMES.SUB_COLUMN_NAME_MAIN,
  SUB_COLUMN_NAME_SUB: FIELD_PROPERTY_NAMES.SUB_COLUMN_NAME_SUB,
  SUB_MIN_NUMBER_OF_REC: FIELD_PROPERTY_NAMES.SUB_MIN_NUMBER_OF_REC,
  SUB_MAX_NUMBER_OF_REC: FIELD_PROPERTY_NAMES.SUB_MAX_NUMBER_OF_REC,
  SUB_REC_EXTENDABLE: FIELD_PROPERTY_NAMES.SUB_REC_EXTENDABLE,
  SUB_REC_DELETABLE: FIELD_PROPERTY_NAMES.SUB_REC_DELETABLE,
  SUBFORM_PURE: FIELD_PROPERTY_NAMES.SUBFORM_PURE,
  HIDDEN: FIELD_PROPERTY_NAMES.HIDDEN,
  SAVE_DATA: FIELD_PROPERTY_NAMES.SAVE_DATA,
  UNIQUE: FIELD_PROPERTY_NAMES.UNIQUE,
  NO_CLONING: FIELD_PROPERTY_NAMES.NO_CLONING,
  MULTISELECT: FIELD_PROPERTY_NAMES.MULTISELECT,
  CREATE_NEW_ELEMENT: FIELD_PROPERTY_NAMES.CREATE_NEW_ELEMENT,
  TEMPLATE_ITEM: FIELD_PROPERTY_NAMES.TEMPLATE_ITEM,
  FORMATTED_TEXT: FIELD_PROPERTY_NAMES.FORMATTED_TEXT,
  OPTIONS_JSON: FIELD_PROPERTY_NAMES.OPTIONS_JSON,
  IS_TECHNICAL: FIELD_PROPERTY_NAMES.IS_TECHNICAL,
  IS_STATIC: FIELD_PROPERTY_NAMES.IS_STATIC,
  HTML_VALUE: FIELD_PROPERTY_NAMES.HTML_VALUE,
  DROPDOWN_ONLY_ONE: FIELD_PROPERTY_NAMES.DROPDOWN_ONLY_ONE,
  FORM_DATA_PROCESS_ID: FIELD_PROPERTY_NAMES.FORM_DATA_PROCESS_ID,
  MAP_DATA_ENTITY: FIELD_PROPERTY_NAMES.MAP_DATA_ENTITY,
  MAP_PROPERTIES: FIELD_PROPERTY_NAMES.MAP_PROPERTIES,
  MAP_DEFAULT_ADDRESS_EXP: FIELD_PROPERTY_NAMES.MAP_DEFAULT_ADDRESS_EXP,
  EXPRESSION: FIELD_PROPERTY_NAMES.EXPRESSION,
  VALUE_FROM_PARAM: FIELD_PROPERTY_NAMES.VALUE_FROM_PARAM,
  PROPERTY_OVERRIDE: FIELD_PROPERTY_NAMES.PROPERTY_OVERRIDE,
  CALENDAR_OPTIONS: FIELD_PROPERTY_NAMES.CALENDAR_OPTIONS,

  TIME_FORMAT: FIELD_PROPERTY_NAMES.TIME_FORMAT,
  DIRECT_INPUT_ENTRY: FIELD_PROPERTY_NAMES.DIRECT_INPUT_ENTRY,
  IS_TIME_SELECT: FIELD_PROPERTY_NAMES.IS_TIME_SELECT,
  START_TIME: FIELD_PROPERTY_NAMES.START_TIME,
  END_TIME: FIELD_PROPERTY_NAMES.END_TIME,
  TIME_STEP: FIELD_PROPERTY_NAMES.TIME_STEP,
  MIN: FIELD_PROPERTY_NAMES.MIN,
  NUMBER_MIN_EXP: 'numberMinExp',
  MAX: FIELD_PROPERTY_NAMES.MAX,
  NUMBER_MAX_EXP: 'numberMaxExp',
  DECIMAL: FIELD_PROPERTY_NAMES.DECIMAL,
  PREFIX: FIELD_PROPERTY_NAMES.PREFIX,
  SUFFIX: FIELD_PROPERTY_NAMES.SUFFIX,
  MIN_LENGTH: FIELD_PROPERTY_NAMES.MIN_LENGTH,
  MAX_LENGTH: FIELD_PROPERTY_NAMES.MAX_LENGTH,
  MAX_FILE_SIZE: FIELD_PROPERTY_NAMES.MAX_FILE_SIZE,
  FILE_TYPES: FIELD_PROPERTY_NAMES.FILE_TYPES,
  PATTERN: FIELD_PROPERTY_NAMES.PATTERN,
  MIN_EXP: FIELD_PROPERTY_NAMES.MIN_EXP,
  MAX_EXP: FIELD_PROPERTY_NAMES.MAX_EXP,
  REQUIRED: FIELD_PROPERTY_NAMES.REQUIRED,
  ROWS: FIELD_PROPERTY_NAMES.ROWS,

  LABEL_EXP: DYNAMIC_PROPERTY_NAMES.LABEL_EXP,
  VALUE_EXP: DYNAMIC_PROPERTY_NAMES.VALUE_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  LIST_EXP: DYNAMIC_PROPERTY_NAMES.LIST_EXP,
  SAVE_EXP: DYNAMIC_PROPERTY_NAMES.SAVE_EXP,
  FILTER_EXP: DYNAMIC_PROPERTY_NAMES.FILTER_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_NAMES.COLLAPSED_EXP,
  REQUIRED_EXP: DYNAMIC_PROPERTY_NAMES.REQUIRED_EXP,

  LIST_SOURCE: FIELD_PROPERTY_NAMES.LIST_SOURCE,
  SQL_CHOSEN_SOURCE: FIELD_PROPERTY_NAMES.SQL_CHOSEN_SOURCE,
  SUB_FORM_PROPS: FIELD_PROPERTY_NAMES.SUB_FORM_PROPS,

  DROPDOWN_NAME: FIELD_PROPERTY_NAMES.DROPDOWN_NAME,

  TIME_SELECT_FORM: FIELD_PROPERTY_NAMES.TIME_SELECT_FORM,
}
